/* eslint-disable camelcase */
export type CommunicationSender = {
  email: string;
  name: string;
};

export type CommunicationCertificate = {
  id: string;
  status: string;
  date: Date;
};

export type CommunicationRecipient = {
  _id?: string;
  name: string;
  email: string;
  messageId: string;
  status: string;
  reject_reason: string;
  queued_reason: string;
  smtp_event: {};
  opens_detail: [];
};

export type CommunicationInvalidRecipient = {
  _id?: string;
  name: string;
  email: string;
  reason: string;
};

export type Communication = {
  _id?: string;
  date: Date;
  society: string;
  user: string;
  sender: CommunicationSender;
  recipients: CommunicationRecipient[];
  invalidRecipients: CommunicationInvalidRecipient[];
  presetGroup: string;
  subject: string;
  bodySummary: string;
  body: string;
  attachments: string[];
  status: string;
  isUnread: boolean;
  isArchived: boolean;
  isFavorite: boolean;
  certificate: CommunicationCertificate;
};

export enum CommunicationiCalEventKey {
  BOARD = 'board', // eslint-disable-line no-unused-vars
  COUNCIL = 'council', // eslint-disable-line no-unused-vars
}

export enum CommunicationiCalEventType {
  BOARD = 'Board', // eslint-disable-line no-unused-vars
  COUNCIL = 'Council', // eslint-disable-line no-unused-vars
}

export type CommunicationiCal = {
  eventKey: CommunicationiCalEventKey;
  eventType: CommunicationiCalEventType;
  eventName: string;
  eventDate: Date;
  eventLink: string;
  societyName: string;
  societyEmail: string;
};
